import { Trans } from '@lingui/react/macro';
import { formatDistanceToNow, isToday } from 'date-fns';

import { parseAndFormatDate } from '@/utils/parseDate';

import { useGetDateFNSLocale } from '../../../../locales/helpers';

interface DateDisplayProps {
  date: string | Date;
}

export const DateDisplay = ({ date }: DateDisplayProps) => {
  const dateLocale = useGetDateFNSLocale();

  return (
    <span className="vai-text-[12px] vai-font-medium vai-text-[#4A4F55]">
      <Trans>Last taken</Trans>{' '}
      {isToday(new Date(date))
        ? formatDistanceToNow(new Date(date), {
            locale: dateLocale,
            addSuffix: true,
          }).replace(' about', '')
        : parseAndFormatDate(new Date(date).toISOString(), 'PP', dateLocale)}
    </span>
  );
};
